import {
	EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX,
	EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX,
} from '../react-router/routes/PatientPortraitRoutes/PatientPortraitRoutes.utils';

export enum NavinaScreenLayout {
	Embedded = 'Embedded',
	Overlay = 'Overlay',
	FullScreen = 'FullScreen',
}

export function getCurrentScreenLayout(): NavinaScreenLayout {
	return getScreenLayout({ locationPathname: globalThis.location.pathname });
}

interface GetScreenLayoutArgs {
	readonly locationPathname: string;
}

export function getScreenLayout({ locationPathname }: GetScreenLayoutArgs): NavinaScreenLayout {
	const localeLocationPathname = locationPathname.toLocaleLowerCase();
	if (localeLocationPathname.includes(`${EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX}/`)) {
		return NavinaScreenLayout.Embedded;
	}
	if (localeLocationPathname.includes(`${EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX}/`)) {
		return NavinaScreenLayout.Overlay;
	}
	return NavinaScreenLayout.FullScreen;
}

function isScreenLayoutOverlay(screenLayout: NavinaScreenLayout): boolean {
	return screenLayout === NavinaScreenLayout.Overlay;
}

export function isScreenLayoutEmbedded(screenLayout: NavinaScreenLayout): boolean {
	return screenLayout === NavinaScreenLayout.Embedded;
}

export function isScreenLayoutFullScreen(screenLayout: NavinaScreenLayout): boolean {
	return screenLayout === NavinaScreenLayout.FullScreen;
}

export function isScreenLayoutEmbeddedOrOverlay(screenLayout: NavinaScreenLayout): boolean {
	if (isScreenLayoutOverlay(screenLayout)) {
		return true;
	}

	if (isScreenLayoutEmbedded(screenLayout)) {
		return true;
	}

	return false;
}

/**
 * Returns the route prefix that corresponds to the given screen layout
 * (e.g. `Embedded` -> `/embedded`, `Overlay` -> `/overlay`, `FullScreen` -> ``).
 * Use this when composing routes that should respect the embedded/overlay
 * convention (e.g. `${prefix}/quality-workspace`).
 */
export function getScreenLayoutPathPrefixOrEmpty(screenLayout: NavinaScreenLayout): string {
	if (isScreenLayoutEmbedded(screenLayout)) {
		return EMBEDDED_PATIENT_PORTRAIT_PATH_PREFIX;
	}
	if (isScreenLayoutOverlay(screenLayout)) {
		return EMBEDDED_LEGACY_APPOINTMENT_PORTRAIT_PATH_PREFIX;
	}
	return '';
}

export function isCurrentScreenLayoutEmbeddedOrOverlay(): boolean {
	const currentScreenLayout = getCurrentScreenLayout();
	return isScreenLayoutEmbeddedOrOverlay(currentScreenLayout);
}

const initialScreenLayout = getCurrentScreenLayout();
export function isInitialScreenLayoutEmbeddedOrOverlay(): boolean {
	return isScreenLayoutEmbeddedOrOverlay(initialScreenLayout);
}
